export const COMPARISON_OPTIONS = [
    {
        label: '<',
        value: '<',
    },
    {
        label: '<=',
        value: '<=',
    },
    {
        label: '>',
        value: '>',
    },
    {
        label: '>=',
        value: '>=',
    },
    {
        label: '=',
        value: '===',
    },
];
